module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter",
      "id": "ach5",
      "title": "Chocolate “Malted” Waffle"
    }
  }, [_c('p', {
    staticClass: "h2"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_15",
      "title": "15"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Contents#ch5"
    }
  }, [_vm._v("Chocolate “Malted” Waffle")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_c('i', [_vm._v("This recipe is for when you want to start your day off sweet, but not cloyingly so. The maca root powder recreates that nutty toasted flavor of malted milk powder, while also giving you a bit of a super food boost. This is a breakfast that seems worse for you than it is. Serve warm with Aquafaba and maple syrup and/or fruit.")])]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("1 tablespoon white vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("2½ cups almond milk")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("2 cups all-purpose flour")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("½ cup maca root powder")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("½ cup cocoa powder")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("⅛ teaspoon kosher salt")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("⅔ cup aquafaba")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("pinch cream of tartar or 4 drops lemon juice")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("¼ cup sugar")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("½ teaspoon vanilla extract")]), _vm._v(" "), _c('p', {
    staticClass: "recb"
  }, [_vm._v("¼ cup coconut oil, melted")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_c('b', [_vm._v("1.")]), _vm._v(" In a small bowl, stir the vinegar into the almond milk and set aside for at least 5 minutes. This makes it much more like buttermilk.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_c('b', [_vm._v("2.")]), _vm._v(" In a separate bowl, mix the flour with the maca root powder, cocoa powder, and salt.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_c('b', [_vm._v("3.")]), _vm._v(" Using a stand mixer, combine your aquafaba and cream of tartar or lemon juice, and whip on medium speed for about 5 minutes. You want to beat the aquafaba to soft peaks, which means that when you remove the whisk, the tip of the peak will collapse/fold over.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_c('b', [_vm._v("4.")]), _vm._v(" With the mixer still on medium, slowly sprinkle in the sugar. Continue to beat until the meringues are thick, shiny, and stiff peaked. Mix in the vanilla and the melted coconut oil until fully combined.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_c('b', [_vm._v("5.")]), _vm._v(" Stir together the almond milk mixture with the flour mixture. Fold the meringue into the milk and flour batter until mixed together.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_c('b', [_vm._v("6.")]), _vm._v(" Preheat your waffle iron until it is hot and ready.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_c('b', [_vm._v("7.")]), _vm._v(" Once the pan is hot, ladle a ¼- to ½-cup scoop of batter, depending on the size of your waffle iron.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("8.")]), _vm._v(" Cook according to your waffle iron instructions.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("YIELD:")]), _vm._v(" 8 to 12 waffles, depending on size of waffle maker"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("PREP TIME:")]), _vm._v(" 20 minutes"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("COOK TIME:")]), _vm._v(" 15 minutes")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-455c1145","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Chapter005.vue
// module id = 90
// module chunks = 0